import { SharedAngular } from '@Client/@types/sharedAngular';
import angular from 'angular';
import { IStateService } from 'angular-ui-router';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

angular.module('flowingly.runner.library').config(config);
config.$inject = ['$stateProvider'];

function config($stateProvider) {
  $stateProvider.state(STATE_MAPPINGS.libraryFormTheme, {
    url: '/formthemes/{formThemeId}?copy',
    params: {
      title: 'Form Theme',
      copy: { type: 'bool', value: false }
    },
    views: {
      childcontent: {
        controllerAs: '$ctrl',
        controller: [
          'APP_CONFIG',
          '$state',
          function (
            APP_CONFIG: SharedAngular.APP_CONFIG,
            $state: IStateService
          ) {
            this.stateMappings = STATE_MAPPINGS;
            if (!APP_CONFIG.allowWorkflow) {
              $state.go(STATE_MAPPINGS.library);
            }

            this.formThemeId = $state?.params?.formThemeId;
            this.copy = $state?.params?.copy;
          }
        ],
        template: require('./runner.formtheme.tmpl.html').default
      }
    }
  });
}
